import React from 'react'
import { StyleSheet, View } from 'react-native'
import ThemedPressable from 'components/atoms/ThemedPressable'
import Icon from 'components/atoms/Icon'
import Text from 'theme/Text'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import { colorList } from 'utils/colors'
import { ThemedValues } from 'styles/themed'

const CoworkerSelectionField = ({ title, selection, onPress }) => {
	return (
		<ThemedPressable
			onPress={ onPress }
			accessibilityRole="button"
			accessibilityLabel={ selection ? `${title}: ${selection}` : title }
			style={ styles.field }>
			<View style={ styles.text }>
				<Text style={ selection ? styles.label : styles.value }>{ title }</Text>
				{ Boolean( selection ) && <Text style={ styles.value }>{ selection }</Text> }
			</View>
			<Icon icon={ IconSystemConstants.CARET_RIGHT } size={ 18 } color={ colorList.TEXT_HINT.primary } />
		</ThemedPressable>
	);
};

const styles = StyleSheet.create({
	field: {
		flex: 0,
		minHeight: 48,
		flexDirection: 'row',
		alignItems: 'center',
		gap: 12,
		paddingHorizontal: 16,
		paddingVertical: 12,
		borderWidth: 1,
		borderColor: colorList.GREY.dark,
		borderRadius: ThemedValues.borderRadius,
		backgroundColor: colorList.WHITE.primary,
	},
	text: { flex: 1, minWidth: 0, gap: 4 },
	label: { fontSize: 12, color: colorList.TEXT_HINT.primary },
	value: { fontSize: 16, color: colorList.TEXT.primary },
});

export default CoworkerSelectionField;
